import { AttachmentDto, UserDto } from 'src/Services/API/generated';

export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export const getNextTaskStatus = (status: TaskStatus): TaskStatus => {
  switch (status) {
    case TaskStatus.TODO:
      return TaskStatus.IN_PROGRESS;
    case TaskStatus.IN_PROGRESS:
      return TaskStatus.DONE;
    case TaskStatus.DONE:
      return TaskStatus.TODO;
  }
};

export enum TaskCategory {
  TECHNIQUE = 'TECHNIQUE',
  VIE_MAISON = 'VIE_MAISON',
  GESTION = 'GESTION',
}

export enum TaskSubCategory {
  // Technique
  PLOMBERIE = 'PLOMBERIE',
  ELECTRICITE = 'ELECTRICITE',
  MENUISERIES = 'MENUISERIES',
  PEINTURE_ENDUITS = 'PEINTURE_ENDUITS',
  REPARATIONS_DIVERSES = 'REPARATIONS_DIVERSES',
  JARDINAGE = 'JARDINAGE',

  // Vie de la maison
  MENAGE_RANGEMENT = 'MENAGE_RANGEMENT',
  DECORATION = 'DECORATION',
  COURSES_APPROVISIONNEMENT = 'COURSES_APPROVISIONNEMENT',

  // Gestion
  ADMINISTRATIF = 'ADMINISTRATIF',
  COMPTABILITE = 'COMPTABILITE',
  JURIDIQUE = 'JURIDIQUE',
  SOURCING_ACHATS = 'SOURCING_ACHATS',
  GESTION_SINISTRES = 'GESTION_SINISTRES',
  RELATIONS_EXTERIEURES = 'RELATIONS_EXTERIEURES',
}

// Mapping des sous-catégories vers leur catégorie parente
export const SUBCATEGORY_TO_CATEGORY: Record<TaskSubCategory, TaskCategory> = {
  // Technique
  [TaskSubCategory.PLOMBERIE]: TaskCategory.TECHNIQUE,
  [TaskSubCategory.ELECTRICITE]: TaskCategory.TECHNIQUE,
  [TaskSubCategory.MENUISERIES]: TaskCategory.TECHNIQUE,
  [TaskSubCategory.PEINTURE_ENDUITS]: TaskCategory.TECHNIQUE,
  [TaskSubCategory.REPARATIONS_DIVERSES]: TaskCategory.TECHNIQUE,
  [TaskSubCategory.JARDINAGE]: TaskCategory.TECHNIQUE,

  // Vie de la maison
  [TaskSubCategory.MENAGE_RANGEMENT]: TaskCategory.VIE_MAISON,
  [TaskSubCategory.DECORATION]: TaskCategory.VIE_MAISON,
  [TaskSubCategory.COURSES_APPROVISIONNEMENT]: TaskCategory.VIE_MAISON,

  // Gestion
  [TaskSubCategory.ADMINISTRATIF]: TaskCategory.GESTION,
  [TaskSubCategory.COMPTABILITE]: TaskCategory.GESTION,
  [TaskSubCategory.JURIDIQUE]: TaskCategory.GESTION,
  [TaskSubCategory.SOURCING_ACHATS]: TaskCategory.GESTION,
  [TaskSubCategory.GESTION_SINISTRES]: TaskCategory.GESTION,
  [TaskSubCategory.RELATIONS_EXTERIEURES]: TaskCategory.GESTION,
};

export interface TaskRelatedEntityDto {
  id: string;
  title: string;
  type: 'project' | 'event' | 'expense' | 'checklist' | 'communityFeedItem';
}

export type RelatedEntityType = 'project' | 'event' | 'expense' | 'checklist' | 'communityFeedItem';

export interface RelatedEntityInput {
  type: RelatedEntityType;
  id: string;
}

export interface TaskDto {
  id: string;
  title: string;
  description?: string;
  status: TaskStatus;
  category?: TaskCategory;
  subCategory?: TaskSubCategory;
  dueDate?: string;
  timeSpentMinutes?: number;
  requiresOnSite: boolean;
  assetId: string;
  createdBy: UserDto;
  assignedTo?: UserDto;
  relatedEntities: TaskRelatedEntityDto[];
  attachments: AttachmentDto[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaskDto {
  title: string;
  description?: string;
  status?: TaskStatus;
  category?: TaskCategory | null;
  subCategory?: TaskSubCategory | null;
  dueDate?: string;
  timeSpentMinutes?: number;
  requiresOnSite?: boolean;
  assignedToId?: string;
  relatedEntities?: RelatedEntityInput[];
  attachmentIds?: string[];
}

export type UpdateTaskDto = Partial<CreateTaskDto>;

export interface MyTaskSummaryDto {
  id: string;
  title: string;
  status: TaskStatus;
  dueDate?: string;
  assetId: string;
  assetName: string;
}
